import { withTimeout } from './search-state.js';

let client;
let pending;

export function getNostoClient() {
  if (window.themeTrackingSuppressed) return Promise.reject(new Error('Nosto search is excluded in this country'));
  if (client) return Promise.resolve(client);
  if (!pending) {
    pending = withTimeout(new Promise((resolve, reject) => {
      if (typeof window.nostojs !== 'function') {
        reject(new Error('Nosto is unavailable'));
        return;
      }
      window.nostojs(api => { client = api; resolve(api); });
    })).catch(error => { pending = undefined; throw error; });
  }
  return pending;
}

export function recordNosto(api, method, ...args) {
  try {
    Promise.resolve(api?.[method]?.(...args)).catch(() => {});
  } catch (error) {
    return;
  }
}

export function recordSearchSubmission(api, query, storage) {
  try {
    storage?.removeItem('nosto-search-submit');
    if (!api) storage?.setItem('nosto-search-submit', query);
  } catch (error) {}
  if (api) recordNosto(api, 'recordSearchSubmit', query);
}

export function flushSearchSubmission(api, query, storage) {
  try {
    if (storage?.getItem('nosto-search-submit') !== query) return;
    storage.removeItem('nosto-search-submit');
  } catch (error) { return; }
  recordNosto(api, 'recordSearchSubmit', query);
}
